import {createFeatureSelector, createSelector} from '@ngrx/store';
import {
  StreamTranscodingConfigurationsState,
  streamTranscodingConfigurationsAdapter
} from './stream-transcoding-configurations.state';

export const streamTranscodingConfigurationsFeatureKey = 'streamTranscodingConfigurations';

export const selectStreamTranscodingConfigurationsState =
  createFeatureSelector<StreamTranscodingConfigurationsState>(streamTranscodingConfigurationsFeatureKey);

const { selectIds, selectEntities, selectAll, selectTotal } =
  streamTranscodingConfigurationsAdapter.getSelectors(selectStreamTranscodingConfigurationsState);

export const selectAllStreamTranscodingConfigurationIds = selectIds;
export const selectStreamTranscodingConfigurationEntities = selectEntities;
export const selectAllStreamTranscodingConfigurations = selectAll;
export const selectStreamTranscodingConfigurationsTotal = selectTotal;

export const selectStreamTranscodingConfigurationsLoading = createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.loading
);

export const selectStreamTranscodingConfigurationsLoaded = createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.loaded
);

export const selectStreamTranscodingConfigurationsError = createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.error
);

export const selectStreamTranscodingConfigurationCreating = createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.creating
);

export const selectStreamTranscodingConfigurationUpdating = (id: string) => createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.updating[id] || false
);

export const selectStreamTranscodingConfigurationDeleting = (id: string) => createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.deleting[id] || false
);

export const selectSelectedStreamTranscodingConfigurationId = createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => state.selectedId
);

export const selectSelectedStreamTranscodingConfiguration = createSelector(
  selectStreamTranscodingConfigurationEntities,
  selectSelectedStreamTranscodingConfigurationId,
  (entities, id) => (id ? entities[id] : null)
);

export const selectStreamTranscodingConfigurationById = (id: string) => createSelector(
  selectStreamTranscodingConfigurationEntities,
  (entities) => entities[id] || null
);

export const selectStreamTranscodingConfigurationsHasErrors = createSelector(
  selectStreamTranscodingConfigurationsState,
  (state) => {
    const hasUpdateError = Object.values(state.updateError).some(Boolean);
    const hasDeleteError = Object.values(state.deleteError).some(Boolean);

    return !!(state.error || state.createError || hasUpdateError || hasDeleteError);
  }
);

